export default "__VITE_ASSET__69e48098__"